import { render, staticRenderFns } from "./GntTypeMenuView.vue?vue&type=template&id=5d749ada"
import script from "./GntTypeMenuView.vue?vue&type=script&lang=js"
export * from "./GntTypeMenuView.vue?vue&type=script&lang=js"
import style0 from "./GntTypeMenuView.vue?vue&type=style&index=0&id=5d749ada&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VRow})
